import {Divider, Paper, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Footer from "./Footer";
import {Container} from "@mui/system";
import React, {useEffect, useState} from "react";
import ButtonAdd from "../../components/UI/button/ButtonAdd";
import {ReactComponent as Advantages1} from "../../components/Icons/advantages1.svg"
import {ReactComponent as Advantages2} from "../../components/Icons/advantages2.svg"
import {ReactComponent as Advantages3} from "../../components/Icons/advantages3.svg"
import {ReactComponent as Advantages4} from "../../components/Icons/advantages4.svg"
import {UpMeBannerCarousel} from "../../components/UI/carousel/UpMeBannerCarousel";
import kitchen from "../../components/Icons/kitchen.png";
import steps from "../../components/Icons/steps.png";
import services1 from "../../components/Icons/services1.png";
import services2 from "../../components/Icons/services2.png";
import services3 from "../../components/Icons/services3.png";
import {useNavigate} from "react-router-dom";
import {authorization, authorizedOrganization} from "../../Constants";
import {saveAuthReturnPath} from "../../utils/authReturnPath";
import UtilityService from "../../API/common/UtilityService";
import Card from "../../components/UI/Card";
import {Login} from "@mui/icons-material";
import KuhniVersoMebel from "../../components/KuhniVersoMebel";
import {kuhniVersoTabletContainerQuerySx} from "../../utils/isKuhniVersoMebelDomain";

const advantages = [
    {text: "Удобная форма заявки", icon: <Advantages1/>},
    {text: "Огромный выбор производителей", icon: <Advantages2/>},
    {text: "Самые выгодные предложения на рынке", icon: <Advantages3/>},
    {text: "Скидки и Акции", icon: <Advantages4/>}]

const popularServices = [
    {createType: "CUT", text: "Заказать распил", img: services1},
    {createType: "CUT_PROCESSING", text: "Заказать распил с обработкой", img: services2},
    {createType: "CUT_PROCESSING_ACCESSORIES", text: "Заказать распил с обработкой и фурнитурой", img: services3}]

const Home = ({isUpMe, domainName}) => {
    const isKuhniVersoMebel = domainName === "kuhni-verso-mebel.upme.by" || domainName === "kuhni-verso-mebel.t.upme.by"

    const navigate = useNavigate();
    const auth = authorization + '/oauth2/authorization/' + window.location.host + '-authorization-code';
    const redirectToAuth = () => {
        saveAuthReturnPath();
        window.location.href = auth;
    };
    const [profile, setProfile] = useState(null)
    const [banners, seBanners] = useState([])

    const isOrganization = profile?.userRoles?.some(role => authorizedOrganization.includes(role.name))

    useEffect(() => {
        const profile = JSON.parse(localStorage.getItem("profile"))
        setProfile(profile)

        UtilityService.getById(1)
            .then((response) => {
                const pictures = response?.data?.pictures;
                seBanners(Array.isArray(pictures) ? pictures : []);
            })
            .catch((error) => {
                console.error("Home: banner load failed", error);
                seBanners([]);
            });
    }, []);

    const createRequest = () => {
        profile ? navigate('/customer/orders') : redirectToAuth()
    }
    const orderCutting = (createType) => {
        createType === "CUT_PROCESSING_ACCESSORIES"
            ? navigate(`/repair-work`)
            : profile
                ? navigate(`/customer/orders?create=${createType}`)
                : redirectToAuth()
    }

    return (
        <>
            <Paper sx={{
                color: (theme) => theme.palette.text.main,
                width: '100%',
                padding: "40px 0",
                display: 'flex',
                justifyContent: "space-between",
                flexGrow: 1,
                ...(isKuhniVersoMebel ? {
                    '@media (max-width: 834px)': {
                        paddingTop: "20px",
                    },
                } : {}),
            }}>
                <Container sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "100px",
                        ...(isKuhniVersoMebel ? kuhniVersoTabletContainerQuerySx : {}),
                        ...(isKuhniVersoMebel ? {
                            '@media (max-width: 599px)': {
                                padding: 0,
                            },
                        } : {}),
                    },
                }}>
                    {/* На upme-доменах главный баннер должен работать без наложения кухни-карусели */}
                    {isKuhniVersoMebel && !isUpMe && <KuhniVersoMebel/>}
                    {isUpMe && <Box sx={{
                        display: 'flex', flexDirection: "column",
                        alignItems: "center", gridGap: "40px",

                    }}>
                        <UpMeBannerCarousel banners={banners}/>
                        <Box sx={{
                            display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center",

                        }}>
                            {advantages.map((el, i) => {
                                return <Box key={i} sx={{
                                    boxSizing: "border-box",
                                    display: 'flex',
                                    alignItems: 'center',
                                    gridGap: "16px",
                                    padding: "20px",
                                    backgroundColor: (theme) => theme.palette.background.grey,
                                    width: '393px',
                                    height: '84px',
                                    borderRadius: "8px",
                                    '@media (max-width: 1620px)': {
                                        width: "351px",
                                    },

                                }}>
                                    <Box sx={{width: 44, height: 44}}>{el.icon}</Box>
                                    <Typography sx={{width: 200, lineHeight: 1}}>
                                        {el.text}
                                    </Typography>
                                </Box>
                            })}
                        </Box>
                    </Box>}

                    {(domainName && !isKuhniVersoMebel) && <Box sx={{
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "40px",
                        justifyContent: "center",
                        width: "100%",
                    }}>
                        <Typography sx={{
                            fontSize: "40px", fontWeight: 700, lineHeight: 1,
                            '@media (max-width: 1450px)': {
                                fontSize: "28px",
                            }
                        }}>
                            Популярные услуги
                        </Typography>
                        <Box sx={{
                            display: "flex", gap: "16px",
                        }}>
                            {popularServices.map((el, i) => {
                                return <Card
                                    key={i}
                                    isHome={true}
                                    element={el}
                                    imgWidth={227}
                                    clickable={!isOrganization}
                                    onClickHandle={() => orderCutting(el.createType)}/>
                            })}
                        </Box>
                    </Box>}
                    {isUpMe && <Box sx={{
                        display: 'flex',
                        alignItems: "center",
                        boxSizing: "border-box",
                        backgroundColor: (theme) => theme.palette.background.grey,
                        borderRadius: "16px",
                        padding: "70px",
                        gap: "70px",
                        width: "100%",

                    }}>
                        <Box sx={{
                            height: '587px',
                            minWidth: "678px",
                            backgroundColor: "grey",
                            borderRadius: "8px",
                            backgroundImage: `url(${kitchen})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",

                        }}/>
                        <Box sx={{
                            display: 'flex',
                            flexDirection: "column",
                            width: "550px",
                            gap: "40px",

                        }}>
                            <Typography sx={{
                                fontSize: "40px", fontWeight: 700, lineHeight: 1.2,

                            }}>
                                Добро пожаловать в UpMe!
                            </Typography>
                            <Box sx={{
                                display: 'flex',
                                flexDirection: "column",
                                gap: "16px",
                            }}>
                                <Typography sx={{fontSize: 16, lineHeight: 1.2}}>
                                    Ваш онлайн-конструктор производственных заказов из ДСП.
                                </Typography>
                                <Typography sx={{textWrap: "wrap", fontSize: 16, lineHeight: 1.2}}>
                                    Уже второе десятилетие мы готовы воплотить в реальность Вашу мечту о красивой,
                                    удобной
                                    мебели из ДСП, помочь реализовать любые дизайнерские фантазии с минимальными
                                    затратами
                                    времени и денежных средств.
                                </Typography>
                                <Typography sx={{textWrap: "wrap", fontSize: 16, lineHeight: 1.2}}>
                                    Создайте заявку на изготовление мебели — выберите своего мастера — получите новую
                                    мебель
                                    и наслаждайтесь уютом!
                                </Typography>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                gap: "8px",
                            }}>
                                <Box sx={{
                                    boxSizing: "border-box",
                                    width: 270,
                                    height: 132,
                                    borderRadius: "8px",
                                    padding: "16px",
                                    border: (theme) => `${theme.palette.primary.main} 2px dashed`,
                                }}>
                                    <Typography sx={{
                                        fontSize: "28px",
                                        fontWeight: 700,
                                        color: (theme) => theme.palette.primary.main
                                    }}>
                                        24/7
                                    </Typography>
                                    <Typography sx={{fontSize: 16, lineHeight: 1.2,}}>
                                        Оформляйте заказ самостоятельно из любой точки мира
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    boxSizing: "border-box",
                                    width: 131,
                                    height: 132,
                                    borderRadius: "8px",
                                    padding: "16px",
                                    border: (theme) => `${theme.palette.primary.main} 2px dashed`,

                                }}>
                                    <Typography sx={{
                                        fontSize: "28px",
                                        fontWeight: 700,
                                        color: (theme) => theme.palette.primary.main
                                    }}>
                                        2 500+
                                    </Typography>
                                    <Typography sx={{fontSize: 16, lineHeight: 1.2,}}>
                                        постоянных клиентов
                                    </Typography>
                                </Box>
                                <Box sx={{
                                    boxSizing: "border-box",
                                    width: 131,
                                    height: 132,
                                    borderRadius: "8px",
                                    padding: "16px",
                                    border: (theme) => `${theme.palette.primary.main} 2px dashed`,

                                }}>
                                    <Typography sx={{
                                        fontSize: "28px",
                                        fontWeight: 700,
                                        color: (theme) => theme.palette.primary.main
                                    }}>
                                        440
                                    </Typography>
                                    <Typography sx={{fontSize: 16, lineHeight: 1.2,}}>
                                        опытных сотрудников
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                            }}>
                                <ButtonAdd text={"Читать подробнее"} width={226} minWidth={184}
                                           onClick={() => navigate('/contacts')}/>
                                <Divider sx={{bgcolor: (theme) => theme.palette.secondary.add, width: "80px"}}/>
                                <Box sx={{
                                    bgcolor: (theme) => theme.palette.secondary.add,
                                    width: "7px",
                                    height: "7px",
                                    borderRadius: "7px",
                                }}></Box>
                            </Box>
                        </Box>

                    </Box>}
                    {isUpMe && <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: "column",
                        gridGap: "40px",
                        width: "100%",
                        '@media (max-width: 1450px)': {
                            gridGap: "24px",
                            // height: "527px",
                        }
                    }}>
                        <Typography sx={{
                            fontSize: "40px", fontWeight: 700,
                            '@media (max-width: 1450px)': {
                                fontSize: "28px",
                            }
                        }}>
                            Как работает сервис заказа мебели UpMe
                        </Typography>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}>
                            {!isOrganization &&
                                <>
                                    <ButtonAdd text={"Создать заявку"} onClick={createRequest} minWidth={184}
                                               width={226}/>
                                    <Divider sx={{bgcolor: (theme) => theme.palette.secondary.add, width: "80px"}}/>
                                    <Box sx={{
                                        bgcolor: (theme) => theme.palette.secondary.add,
                                        width: "7px",
                                        height: "7px",
                                        borderRadius: "7px",
                                    }}/></>}
                        </Box>

                        <Box sx={{
                            minHeight: '331px',
                            width: "100%",
                            backgroundImage: `url(${steps})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover",
                            '@media (max-width: 1620px)': {
                                minHeight: "300px",
                            },
                        }}/>
                    </Box>}
                </Container>
            </Paper>
            {(isUpMe||isKuhniVersoMebel) && <Footer></Footer>}
        </>
    )
        ;
};

export default Home;